import { useState } from 'react';
import { createPortal } from 'react-dom';
import { faCheck, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { OUTCOMES, REASONS, isSales } from '../../utils/actions';
import { Btn, I, Seg, cx } from './ui';

export default function FinishModal({ x, phone, busy, onDone, onClose }) {
  const batch = x.kind === 'batch';
  const options = OUTCOMES[isSales(x) ? 'sales' : 'service'];
  const [outcome, setOutcome] = useState(batch || !isSales(x) ? 'resolved' : '');
  const [reason, setReason] = useState('');
  const [note, setNote] = useState('');
  const ready = note.trim() && outcome && (outcome !== 'disqualified' || reason);
  const esc = (e) => e.key === 'Escape' && onClose();
  return createPortal(
    <div className={cx('aa', phone && 'ph')}>
      <div className="m-scrim top" onClick={onClose} />
      <div className="m-modal sm" role="dialog" aria-modal="true" aria-labelledby="m-note-t" onKeyDown={esc}>
        <div className="m-mh">
          <div className="m-row">
            <I icon={faPenToSquare} />
            <h2 id="m-note-t">Add a note to finish</h2>
          </div>
        </div>
        <div className="m-mb">
          <div className="m-sub">{x.title}</div>
          {!batch && (
            <div className="m-field">
              <label>Outcome (required)</label>
              <Seg items={options} value={outcome} onChange={setOutcome} label="Outcome" block />
            </div>
          )}
          {outcome === 'disqualified' && (
            <div className="m-field">
              <label>Reason</label>
              <Seg items={REASONS} value={reason} onChange={setReason} label="Reason" block />
            </div>
          )}
          <div className="m-field">
            <label htmlFor="m-note">What was done? (required)</label>
            <textarea
              id="m-note"
              className="m-inp"
              rows={3}
              maxLength={240}
              autoFocus
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Called Gina, Contraband Bayou Air booked for 10:00 AM"
            />
            <div className="m-hint num">{note.length} / 240</div>
          </div>
        </div>
        <div className="m-mf">
          <Btn onClick={onClose}>Cancel</Btn>
          <div className="grow" />
          <Btn
            kind="primary"
            icon={faCheck}
            disabled={!ready || busy}
            onClick={() =>
              onDone({
                note: note.trim(),
                outcome,
                outcomeReason: outcome === 'disqualified' ? reason : null
              })
            }
          >
            Mark done
          </Btn>
        </div>
      </div>
    </div>,
    document.body
  );
}
